import React from "react";
import logo from "../../../assets/images/LOGO.JPG";
import { StyledLogo } from "./StyledLogo";

const Logo = ({ size }) => {
  return <StyledLogo src={logo} alt="logo" size={size} />;
};

export default Logo;
